import * as PartsImports from './partsImports';

const reducers = {
  ...PartsImports,
};

export default reducers;
